import axios from "axios";
import { PresignedUploadRequest } from "src/types";

import { API_URLS } from "src/utils/API_URLS";

const PublicationsService = {
  createContent: async <T>(data: T): Promise<void> => {
    try {
      const url = API_URLS.createPublishedContent;
      await axios.post(url, data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  deleteContent: async (uuid: string): Promise<void> => {
    try {
      const url = API_URLS.deletePublishedContent.replace(
        ":wsPublishedContentUuid:",
        uuid,
      );
      await axios.delete(url);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  createPresignedRequestForContent: async (
    filesData: { wsPublicationTaskUuid: string; wsWorkspaceUuid: string }[],
  ): Promise<PresignedUploadRequest> => {
    try {
      const url = API_URLS.createPresignedRequestForPublishedContent;
      const response = await axios.post<PresignedUploadRequest>(url, filesData);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  downloadContent: async (uuids: string[]): Promise<void> => {
    try {
      const url = API_URLS.downloadPublishedContent;
      await axios.post(url, {
        wsPublicationTaskUuids: uuids,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default PublicationsService;
